import { render, staticRenderFns } from "./Comp45t2.vue?vue&type=template&id=19bc2511&scoped=true&"
import script from "./Comp45t2.vue?vue&type=script&lang=js&"
export * from "./Comp45t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp45t2.vue?vue&type=style&index=0&id=19bc2511&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bc2511",
  null
  
)

export default component.exports